import { com } from '@eidu/form'
import { useEffect, useState } from 'react'
import EntityWithLabelAndRelated from '../domain/entity/EntityWithLabelAndRelated'
import useEntityFetcher from './useEntityFetcher'
import EntityId = com.eidu.sharedlib.entity.EntityId

type UseEntityByIdResult = { entity: EntityWithLabelAndRelated | null | undefined; loading: boolean }

const useEntityById = (id: EntityId | undefined): UseEntityByIdResult => {
  const fetchById = useEntityFetcher()

  const [value, setValue] = useState<EntityWithLabelAndRelated | null | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    let cancelled = false
    if (!id) {
      setValue(undefined)
      setLoading(false)
    } else {
      setLoading(true)
      fetchById(id)
        .then((it) => {
          if (!cancelled) setValue(it)
        })
        .catch(() => {
          if (!cancelled) setValue(null)
        })
        .finally(() => {
          if (!cancelled) setLoading(false)
        })
    }
    return () => {
      cancelled = true
    }
  }, [fetchById, id?.toString()])

  return { entity: value, loading }
}

export default useEntityById
